export default {
  install(Vue) {
    Vue.prototype.$apiLink = (link) => {
      const apiUrl = process.env.VUE_APP_API
      return apiUrl + link
    }
    Vue.prototype.$currency = (currency) => {
      if (currency === 'CZK') return 'Kč'
      return '€'
    }
  },
}
